import SpaceNavItem from './SpaceNavItem'
import {
  Artwork,
  Color,
  Icons,
  NavItemVertical
} from '@eggplant/pattern-library'
import {
  ENVIRONMENTS,
  SPACES,
  SPACE_API_ACCESS,
  renderLinkTo,
  routeLabels
} from '@eggplant/routing'
import { Match } from '@reach/router'

interface Props {
  isCollapsed: boolean
}

const WILDCARD = '/*'

// The "key"s reset the NavGroup state on every route change.

const Top = ({ isCollapsed }: Props) =>
  <>
    <Match path={'/' + SPACES + WILDCARD}>
      {
        () =>
          <SpaceNavItem isCollapsed={isCollapsed} />
      }
    </Match>
    <Match path={'/' + ENVIRONMENTS + WILDCARD}>
      {
        () =>
          <NavItemVertical
            icon={
              <Color
                display='inline'
                variant='darkPurple'
              >
                <Artwork.Environment />
              </Color>
            }
            isCollapsed={isCollapsed}
            label={routeLabels[ENVIRONMENTS]}
          >
            {renderLinkTo(ENVIRONMENTS)}
          </NavItemVertical>
      }
    </Match>
    <Match path={'/' + SPACE_API_ACCESS + WILDCARD}>
      {
        () =>
          <NavItemVertical
            icon={<Icons.ApiAccess aria-hidden />}
            isCollapsed={isCollapsed}
            label={routeLabels[SPACE_API_ACCESS]}
          >
            {renderLinkTo(SPACE_API_ACCESS)}
          </NavItemVertical>
      }
    </Match>
  </>

export default Top
